// extracted by mini-css-extract-plugin
export default {"breadCrumbContainer":"BreadCrumb_breadCrumbContainer__3HSNc","breadCrumbItem":"BreadCrumb_breadCrumbItem__mymEW","breadCrumbActiveItem":"BreadCrumb_breadCrumbActiveItem__i972s"};